import { render, staticRenderFns } from "./ScrollArrow.vue?vue&type=template&id=5680b9b3&"
import script from "./ScrollArrow.vue?vue&type=script&lang=js&"
export * from "./ScrollArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports